/* ====================================================================
 *  persist — гостьовий кошик у localStorage. Ключ задокументований у
 *  docs/LOCALSTORAGE_SCHEMA.md. Для залогінених джерело правди —
 *  Firestore, LS не використовується.
 * ==================================================================== */

import { toCartItem, type CartItem } from "./mapping";

export const LS_KEY = "cart:v2";

export function loadFromLS(): CartItem[] {
  if (!import.meta.client) return [];
  try {
    const raw = JSON.parse(localStorage.getItem(LS_KEY) || "[]");
    if (!Array.isArray(raw)) return [];

    const usable = raw.filter((r) => r && r.key);
    if (raw.length && !usable.length) {
      // Записи без key неможливо ні зберегти, ні видалити — але й тихо
      // губити їх не можна: саме так гостьовий кошик зникав при логіні.
      console.warn("[cart] localStorage entries dropped: no key", raw.length);
    }

    return usable.map((r) => toCartItem(String(r.key), r));
  } catch (e) {
    console.warn("[cart] localStorage read failed", e);
    return [];
  }
}

export function saveToLS(items: CartItem[]): void {
  if (!import.meta.client) return;
  localStorage.setItem(LS_KEY, JSON.stringify(items));
}

export function clearLS(): void {
  if (!import.meta.client) return;
  localStorage.removeItem(LS_KEY);
}
